var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('add-new-post',{on:{"postAdded":_vm.postAdded}}),_c('posts',{ref:"postList"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }